import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// i18n for legacy components
import { withTranslation } from 'react-i18next';
// Custom HOCs
import { withRouter } from '../../helpers/hocs';

// Actions
import { gameActions } from '../../actions';
import { setupSocket, enterBackend, socketOn } from '../../helpers/sockets';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';

class DebriefAggregate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_player: null,
      proposals: [],
    };

    // Bindings
    this.setProposals = this.setProposals.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match.params.id) {
      // dispatch(gameActions.fetchGames(match.params.id))
      fetch(process.env.REACT_APP_API_URL + '/auth/oauth_provider')
        .then((res) => res.json())
        .then((data) => {
          setupSocket(data.io_domain, () => {
            enterBackend({ game_id: match.params.id }, (socketGameData) => {
              console.log({ socketGameData });
            });
            // Sockets!
            socketOn('offer', (m) => {
              dispatch(gameActions.fetchGames(match.params.id));
            }); // socketOn('nodeal', (m) => console.log(m) );
          });
        });
    }
  }

  setProposals(proposals) {
    this.setState({ proposals });
  }

  render() {
    // Extract the game data and validate
    const { game, t } = this.props;
    if (!game.data) return null;

    // The main categories and their buckets
    const mainTags = {
      basic_questions: [],
      value_based: [],
      other: [],
    };

    // The KSI categories and their buckets
    const ksiTags = {
      connection_questions: [],
      excavation_questions: [],
      c_questions: [],
      exploration_questions: [],
      action_questions: [],
      other: [],
    };

    // CATEGORIES: CHART DATA ALL
    game.data.players.forEach(function (players) {
      players.chat.forEach(function (msg) {
        // Get the main and KSI classes
        const { cat_main, cat_ksi } = msg;

        // Assign the main class to the bucket
        if (cat_main?.length > 0) {
          if (mainTags?.[cat_main]) {
            mainTags[cat_main].push(1);
          } else {
            mainTags['other'].push(1);
          }
        }

        // Assign the KSI class to the bucket
        if (cat_ksi?.length > 0) {
          if (ksiTags?.[cat_ksi]) {
            ksiTags[cat_ksi].push(1);
          } else {
            ksiTags['other'].push(1);
          }
        }
      });
    });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title fs-3'>
        {t('Aggregate')}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        {/* MAIN CATEGORIES CHART */}
        <h5 className='mt-4 text-dark'>{t('Question Focus')}</h5>
        <div className='mt-1 pb-2 row'>
          {/* <div className='col-4'>...</div> */}
          <div className='col-12'>
            <HighchartsReact
              containerProps={{ style: { height: '100%', paddingTop: '20px' } }}
              highcharts={Highcharts}
              options={{
                chart: { type: 'column', style: { fontSize: '14px' } },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: {
                  labels: { style: { fontSize: '14px' } },
                  categories: [t('Basic'), t('Value-Based'), t('Other')],
                },
                yAxis: {
                  labels: { style: { fontSize: '14px' } },
                  allowDecimals: false,
                  min: 0,
                  title: { text: '' },
                },
                tooltip: {
                  style: { fontSize: '14px' },
                  formatter: function () {
                    if (this.point.category == 'Total')
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                    else
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                  },
                  //pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>Click to see details.'
                },
                plotOptions: {
                  column: {
                    dataLabels: {
                      enabled: true,
                      crop: false,
                      overflow: 'none',
                    },
                  },
                },
                series: [
                  {
                    name: t('Count'),
                    data: [
                      {
                        y: mainTags.basic_questions.length,
                        color: '#f0c362',
                      },
                      { y: mainTags.value_based.length, color: '#4aa987' },
                      { y: mainTags.other.length, color: '#aaa' },
                    ],
                  },
                ],
              }}
            />
          </div>
        </div>

        {/* KSI CATEGORIES CHART */}
        <h5 className='mt-4 text-dark'>{t('Question Type')}</h5>
        <div className='mt-1 mb-4 pb-2 row'>
          <div className='col-12'>
            <HighchartsReact
              containerProps={{ style: { height: '100%', paddingTop: '20px' } }}
              highcharts={Highcharts}
              options={{
                chart: { type: 'column', style: { fontSize: '14px' } },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: {
                  labels: { style: { fontSize: '14px' } },
                  categories: [
                    t('Connection'),
                    t('Excavation'),
                    t('Clarification'),
                    t('Exploration'),
                    t('Action'),
                    t('Other'),
                  ],
                },
                yAxis: {
                  labels: { style: { fontSize: '14px' } },
                  allowDecimals: false,
                  min: 0,
                  title: { text: '' },
                },
                tooltip: {
                  style: { fontSize: '14px' },
                  formatter: function () {
                    if (this.point.category == 'Total')
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                    else
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                  },
                  //pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>Click to see details.'
                },
                plotOptions: {
                  column: {
                    dataLabels: {
                      enabled: true,
                      crop: false,
                      overflow: 'none',
                    },
                  },
                },
                series: [
                  {
                    name: t('Count'),
                    data: [
                      ksiTags.connection_questions.length,
                      ksiTags.excavation_questions.length,
                      ksiTags.c_questions.length,
                      ksiTags.exploration_questions.length,
                      ksiTags.action_questions.length,
                      ksiTags.other.length,
                    ],
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

// i18n for legacy components
const DebriefAggregateWithTranslation = withTranslation()(DebriefAggregate);
// Router HOC
const DebriefAggregateWithRouter = withRouter(DebriefAggregateWithTranslation);

const mapStateToProps = (state) => {
  const { game } = state;
  return {
    game,
  };
};

export default connect(mapStateToProps)(DebriefAggregateWithRouter);
